import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';

import { PageNotFoundModule } from '@mysvg/page-not-found/page-not-found.module';
import { LoadingComponent } from '@svg-frontends/progress-spinner/loading/loading.component';
import { ClarityWrapperModule } from '@svg-frontends/theming/clarity-wrapper.module';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [CommonModule, ClarityWrapperModule, PageNotFoundModule, LoadingComponent],
	selector: 'svg-frontends-page-logout',
	standalone: true,
	styleUrls: ['./page-logout.component.scss'],
	templateUrl: './page-logout.component.html',
})
export class PageLogoutComponent {}
